/**
 * Mock data for Document Types (Organization Document Configuration)
 * Used in Phase 1: UI-First approach
 */

export const mockDocumentTypes = [
  // LICENSE Category
  {
    id: "type-trade-001",
    verticalId: "vert-uae-001",
    categoryId: "cat-license-001",
    code: "TRADE_LICENSE",
    name: "Trade License",
    nameAr: "الرخصة التجارية",
    hasExpiry: true,
    expiryReminderDays: [90, 60, 30, 7],
    isRenewable: true,
    renewalServiceId: null,
    documentNumberLabel: "License Number",
    documentNumberPattern: "^[A-Z]{2,3}-\\d{6}$",
    allowedFileTypes: ["pdf", "jpg", "png"],
    maxFileSizeMb: 10,
    icon: "description",
    displayOrder: 1,
    isActive: true,
    isSystem: true,
    fieldCount: 3,
    authorityCount: 4,
    createdAt: "2024-01-01T00:00:00Z",
    _isMock: true
  },
  {
    id: "type-freezone-002",
    verticalId: "vert-uae-001",
    categoryId: "cat-license-001",
    code: "FREE_ZONE_LICENSE",
    name: "Free Zone License",
    nameAr: "رخصة المنطقة الحرة",
    hasExpiry: true,
    expiryReminderDays: [90, 60, 30, 7],
    isRenewable: true,
    documentNumberLabel: "License Number",
    documentNumberPattern: null,
    allowedFileTypes: ["pdf"],
    maxFileSizeMb: 10,
    icon: "business",
    displayOrder: 2,
    isActive: true,
    isSystem: false,
    fieldCount: 2,
    authorityCount: 5,
    createdAt: "2024-01-01T00:00:00Z",
    _isMock: true
  },
  {
    id: "type-prof-003",
    verticalId: "vert-uae-001",
    categoryId: "cat-license-001",
    code: "PROFESSIONAL_LICENSE",
    name: "Professional License",
    nameAr: "الرخصة المهنية",
    hasExpiry: true,
    expiryReminderDays: [90, 60, 30, 7],
    isRenewable: true,
    documentNumberLabel: "License Number",
    allowedFileTypes: ["pdf", "jpg", "png"],
    maxFileSizeMb: 10,
    icon: "work",
    displayOrder: 3,
    isActive: true,
    isSystem: false,
    fieldCount: 2,
    authorityCount: 2,
    createdAt: "2024-01-01T00:00:00Z",
    _isMock: true
  },
  // GOV_CARD Category
  {
    id: "type-estab-004",
    verticalId: "vert-uae-001",
    categoryId: "cat-govcard-002",
    code: "ESTABLISHMENT_CARD",
    name: "Establishment Card",
    nameAr: "بطاقة المنشأة",
    hasExpiry: true,
    expiryReminderDays: [90, 60, 30, 7],
    isRenewable: true,
    documentNumberLabel: "Card Number",
    allowedFileTypes: ["pdf", "jpg", "png"],
    maxFileSizeMb: 5,
    icon: "badge",
    displayOrder: 1,
    isActive: true,
    isSystem: true,
    fieldCount: 2,
    authorityCount: 1,
    createdAt: "2024-01-01T00:00:00Z",
    _isMock: true
  },
  {
    id: "type-immig-005",
    verticalId: "vert-uae-001",
    categoryId: "cat-govcard-002",
    code: "IMMIGRATION_CARD",
    name: "Immigration Card",
    nameAr: "بطاقة الهجرة",
    hasExpiry: true,
    expiryReminderDays: [90, 60, 30, 7],
    isRenewable: true,
    documentNumberLabel: "Card Number",
    allowedFileTypes: ["pdf", "jpg", "png"],
    maxFileSizeMb: 5,
    icon: "flight",
    displayOrder: 2,
    isActive: true,
    isSystem: true,
    fieldCount: 1,
    authorityCount: 1,
    createdAt: "2024-01-01T00:00:00Z",
    _isMock: true
  },
  {
    id: "type-labor-006",
    verticalId: "vert-uae-001",
    categoryId: "cat-govcard-002",
    code: "LABOR_CARD",
    name: "Labor Card",
    nameAr: "بطاقة العمل",
    hasExpiry: true,
    expiryReminderDays: [90, 60, 30, 7],
    isRenewable: true,
    documentNumberLabel: "Card Number",
    allowedFileTypes: ["pdf", "jpg", "png"],
    maxFileSizeMb: 5,
    icon: "engineering",
    displayOrder: 3,
    isActive: true,
    isSystem: false,
    fieldCount: 1,
    authorityCount: 1,
    createdAt: "2024-01-01T00:00:00Z",
    _isMock: true
  },
  // FORMATION Category
  {
    id: "type-moa-007",
    verticalId: "vert-uae-001",
    categoryId: "cat-formation-003",
    code: "MOA",
    name: "Memorandum of Association",
    nameAr: "عقد التأسيس",
    hasExpiry: false,
    documentNumberLabel: "Reference Number",
    allowedFileTypes: ["pdf"],
    maxFileSizeMb: 15,
    icon: "gavel",
    displayOrder: 1,
    isActive: true,
    isSystem: false,
    fieldCount: 2,
    authorityCount: 1,
    createdAt: "2024-01-01T00:00:00Z",
    _isMock: true
  },
  // TAX Category
  {
    id: "type-trn-010",
    verticalId: "vert-uae-001",
    categoryId: "cat-tax-005",
    code: "TRN_CERTIFICATE",
    name: "Tax Registration Certificate",
    nameAr: "شهادة التسجيل الضريبي",
    hasExpiry: false,
    documentNumberLabel: "TRN",
    documentNumberPattern: "^100\\d{12}$",
    allowedFileTypes: ["pdf", "jpg", "png"],
    maxFileSizeMb: 5,
    icon: "receipt",
    displayOrder: 1,
    isActive: true,
    isSystem: true,
    fieldCount: 3,
    authorityCount: 1,
    createdAt: "2024-01-01T00:00:00Z",
    _isMock: true
  },
  {
    id: "type-ctreturn-011",
    verticalId: "vert-uae-001",
    categoryId: "cat-tax-005",
    code: "CT_RETURN",
    name: "Corporate Tax Return",
    nameAr: "إقرار ضريبة الشركات",
    hasExpiry: true,
    expiryReminderDays: [90, 60, 30],
    documentNumberLabel: "Return Reference",
    allowedFileTypes: ["pdf"],
    maxFileSizeMb: 10,
    icon: "receipt_long",
    displayOrder: 2,
    isActive: true,
    isSystem: true,
    fieldCount: 6,
    authorityCount: 1,
    createdAt: "2024-01-01T00:00:00Z",
    _isMock: true
  },
  {
    id: "type-audit-012",
    verticalId: "vert-uae-001",
    categoryId: "cat-tax-005",
    code: "AUDIT_REPORT",
    name: "Audited Financial Statements",
    nameAr: "البيانات المالية المدققة",
    hasExpiry: true,
    expiryReminderDays: [90, 60, 30],
    documentNumberLabel: null,
    allowedFileTypes: ["pdf"],
    maxFileSizeMb: 20,
    icon: "assessment",
    displayOrder: 3,
    isActive: true,
    isSystem: true,
    fieldCount: 5,
    authorityCount: 1,
    createdAt: "2024-01-01T00:00:00Z",
    _isMock: true
  },
  {
    id: "type-vat-013",
    verticalId: "vert-uae-001",
    categoryId: "cat-tax-005",
    code: "VAT_CERTIFICATE",
    name: "VAT Registration Certificate",
    nameAr: "شهادة تسجيل ضريبة القيمة المضافة",
    hasExpiry: false,
    documentNumberLabel: "VAT TRN",
    documentNumberPattern: "^100\\d{12}$",
    allowedFileTypes: ["pdf", "jpg", "png"],
    maxFileSizeMb: 5,
    icon: "percent",
    displayOrder: 4,
    isActive: true,
    isSystem: true,
    fieldCount: 2,
    authorityCount: 1,
    createdAt: "2024-01-01T00:00:00Z",
    _isMock: true
  },
  {
    id: "type-vatreturn-014",
    verticalId: "vert-uae-001",
    categoryId: "cat-tax-005",
    code: "VAT_RETURN",
    name: "VAT Return",
    nameAr: "إقرار ضريبة القيمة المضافة",
    hasExpiry: true,
    expiryReminderDays: [30, 14, 7],
    documentNumberLabel: "Return Reference",
    allowedFileTypes: ["pdf"],
    maxFileSizeMb: 10,
    icon: "calculate",
    displayOrder: 5,
    isActive: true,
    isSystem: true,
    fieldCount: 5,
    authorityCount: 1,
    createdAt: "2024-01-01T00:00:00Z",
    _isMock: true
  }
];

export const getDocumentTypesByCategory = (categoryId) => {
  return mockDocumentTypes.filter(t => t.categoryId === categoryId);
};

export const getDocumentTypesByVertical = (verticalId) => {
  return mockDocumentTypes.filter(t => t.verticalId === verticalId);
};

export const getDocumentTypeById = (id) => {
  return mockDocumentTypes.find(t => t.id === id);
};

export const getDocumentTypeByCode = (code) => {
  return mockDocumentTypes.find(t => t.code === code);
};

export const getActiveDocumentTypes = () => {
  return mockDocumentTypes.filter(t => t.isActive);
};

export default mockDocumentTypes;
